import firebase from "firebase/app";
import "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyCYEp9UGlV33gqB3HAuyoFv3T5KChAdvmM",
  authDomain: "fast-resume-85cbe.firebaseapp.com",
  databaseURL: "https://fast-resume-85cbe.firebaseio.com",
  projectId: "fast-resume-85cbe",
  storageBucket: "fast-resume-85cbe.appspot.com",
  messagingSenderId: "863355208233",
  appId: "1:863355208233:web:d4e940c86fd8f227c15238",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
